// Есть ли у компании товар: остаток или посев по нему не равны нулю (остаток бывает и отрицательным).
// Значения приходят строками ("0.00") или null.
const amount = (value) => Number(value) || 0;

export const hasProduct = (company, product) =>
  amount(company.leftovers && company.leftovers[product]) !== 0 ||
  amount(company.sowingareas && company.sowingareas[product]) !== 0;
